<p-floatLabel>
  <p-select #externalSystemStateDropdown
            id="externalSystemDropdown"
            name="externalSystemDropdown"
            [options]="externalSystemStates"
            [(ngModel)]="externalSystemState"
            [showClear]="!isRequired"
            [checkmark]="true"
            styleClass="w-100"
            (onChange)="onSelected()">
    <ng-template let-option pTemplate="item">
      {{ option.label }}
    </ng-template>
  </p-select>
  <label for="externalSystemDropdown">
    <app-label-content [isRequired]="isRequired">
      {{ l('::State') }}
    </app-label-content>
  </label>
</p-floatLabel>